import { useUI } from '../store/ui'
import { Icon } from './Icon'

const TONE: Record<string, string> = { info: 'var(--info)', success: 'var(--success)', warning: 'var(--warning)', danger: 'var(--danger)' }
const ICON: Record<string, string> = { info: 'dot', success: 'check', warning: 'alert', danger: 'alert' }

export function Toast() {
  const { toast, dismissToast } = useUI()
  if (!toast) return null
  return (
    <div className="toast" style={{ borderLeftColor: TONE[toast.tone] }} role="status">
      <span style={{ color: TONE[toast.tone], display: 'flex' }}><Icon name={ICON[toast.tone]} size={18} /></span>
      <span className="msg">{toast.msg}</span>
      <span className="x" onClick={dismissToast}><Icon name="close" size={15} /></span>
    </div>
  )
}
